import { render, staticRenderFns } from "./populate-message-patterns.vue?vue&type=template&id=33327287&scoped=true&"
import script from "./populate-message-patterns.vue?vue&type=script&lang=js&"
export * from "./populate-message-patterns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33327287",
  null
  
)

export default component.exports